<template>
  <section class="w-screen h-screen absolute flex justify-center items-center z-50">
    <div id="modal modal-customer"
      class="modal absolute block bg-white dark:bg-dark-800 w-5/6 sm:w-9/12 md:w-5/12 max-w-lg shadow-md rounded-lg dark:shadow-dark-600"
      :class="{
        'animate__animated animate__zoomIn': showModal,
        'animate__animated animate__zoomOut': !showModal,
      }">
      <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">{{ isEdit ? 'Edit Pengeluaran' : 'Tambah Pengeluaran' }}
        </h5>
      </div>
      <div id="modal-body" class="p-5 space-y-4 max-h-[calc(100dvh-220px)] overflow-y-auto">
        <InputTextAreaCustom v-model="description" id="expenditure-name" label="Deskripsi"
          placeholder="Masukkan deskripsi" input_class="w-full" :valid="validation.description.valid"
          :error-message="validation.description.message" />
        <InputRadio v-model="status" id="status" name="status" label="Status" :options="statusOptions"
          :valid="validation.status.valid" :error-message="validation.status.message" />
        <InputRupiah v-if="isWithdrawal" v-model="withdrawal" id="withdrawal" label="Withdrawal"
          placeholder="Masukkan withdrawal" input_class="w-full" :valid="validation.withdrawal.valid"
          :error-message="validation.withdrawal.message" />
        <InputRupiah v-if="isDeposit" v-model="deposit" id="deposit" label="Deposit"
          placeholder="Masukkan deposit" input_class="w-full" :valid="validation.deposit.valid"
          :error-message="validation.deposit.message" />
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600" @click="closeModal" />
          <SubmitButton id="submit" button_name="Submit" button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4"
            @click="submitPettyCash" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import SubmitButton from '@/components/form/SubmitButton.vue';
import InputTextAreaCustom from '@/components/form/InputTextAreaCustom.vue';
import InputRupiah from '@/components/form/InputRupiah.vue';
import InputRadio from '@/components/form/InputRadio.vue';

export default {
  name: "ModalPettyCash",
  props: {
    petty_cash: {
      type: Object,
      default: null,
    },
    currentCash: {
      type: Number,
      default: 0,
    }
  },
  components: {
    SubmitButton, InputRupiah, InputTextAreaCustom, InputRadio
  },
  data() {
    return {
      showModal: true,
      description: this.petty_cash ? this.petty_cash.description : '',
      withdrawal: this.petty_cash ? this.petty_cash.withdrawal : '',
      deposit: this.petty_cash ? this.petty_cash.deposit : '',
      status: this.petty_cash ? this.petty_cash.status : '',
      isEdit: !!this.petty_cash,
      isDeposit: this.status ? this.status === 'deposit' : false,
      isWithdrawal: this.status ? this.status === 'withdrawal' : false,
      statusOptions: [
        { value: 'withdrawal', label: 'Withdrawal' },
        { value: 'deposit', label: 'Deposit' }
      ],
      validation: {
        description: {
          valid: true,
          message: ''
        },
        withdrawal: {
          valid: true,
          message: ''
        },
        deposit: {
          valid: true,
          message: ''
        },
        status: {
          valid: true,
          message: ''
        }
      },
      field: ['description', 'withdrawal', 'deposit', 'status'],
    };
  },
  computed: {
  },
  watch: {
    petty_cash(newValue) {
      if (newValue) {
        this.description = newValue.description;
        this.withdrawal = newValue.withdrawal;
        this.deposit = newValue.deposit;
        this.status = newValue.status;
        this.isEdit = true;
      } else {
        this.description = '';
        this.withdrawal = '';
        this.deposit = '';
        this.status = '';
        this.isEdit = false;
      }
    },
    status(newValue) {
      this.isWithdrawal = newValue ? newValue === 'withdrawal' : false;
      this.isDeposit = newValue ? newValue === 'deposit' : false;
    }
  },
  methods: {
    ...mapActions('petty_cash', ['createPettyCash', 'updatePettyCash']),
    closeModal() {
      this.showModal = false;
      this.$emit('closeModal');
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200);
    },
    submitPettyCash() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan Pengeluaran?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postPettyCash();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan pengeluaran', life: 3000 });
        }
      });
    },
    async postPettyCash() {
      try {
        const pettyCashData = {
          description: this.description,
          amount_withdrawal: parseFloat(this.withdrawal),
          amount_deposit: parseFloat(this.deposit),
          status: this.status
        };

        const cashRegisters = await this.$store.dispatch(
          "cash_registers/fetchOpenCashRegisters"
        );

        if (!cashRegisters || cashRegisters.length === 0) {
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Tidak ada kas yang dibuka', life: 5000 });
          return;
        }

        // if (cashRegisters.data[0].start_saldo <= this.withdrawal || cashRegisters.data[0].start_saldo <= this.deposit) {
        //   this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Saldo tidak mencukupi', life: 5000 });
        //   return;
        // }

        if (this.withdrawal > this.currentCash) {
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Saldo tidak mencukupi', life: 5000 });
          return;
        }

        // if (this.deposit > this.currentCash) {
        //   this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Saldo tidak mencukupi', life: 5000 });
        //   return;
        // }

        if (this.isEdit && this.petty_cash) {
          pettyCashData.id = this.petty_cash.id;
          await this.updatePettyCash(pettyCashData);
        }
        else {
          pettyCashData.cash_register_id = cashRegisters.data[0].id;
          const response = await this.createPettyCash(pettyCashData);
          console.log('pettyCashData', response);
        }

        this.closeModal();
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Pengeluaran berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save expenditure: ', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    }
  }
}
</script>